module.exports = __webpack_public_path__ + "img/Vector.cf0407e4.svg";